module.exports = __webpack_public_path__ + "img/pulled_pork.e914380f.jpg";